module.exports = __webpack_public_path__ + "img/badge-feed-a-sustainable-future.2b807446.png";